import { useEffect } from "react";

const AuthSessionSync = () => {
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "userToken") {
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return null;
};

export default AuthSessionSync;
